import axios from "axios";
import {
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_ERROR,
} from "../../constants/actionTypes";
import { EVENTS_API } from "../../config/constants";

export const getEvents = () => {
  return (dispatch) => {
    dispatch({
      type: GET_EVENTS,
    });

    return axios.get(EVENTS_API)
      .then((response) => {
        dispatch({
          type: GET_EVENTS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_EVENTS_ERROR,
          payload: err,
        });
      });
  };
};
